export const mastercard = `
    <svg width="37" height="23" viewBox="0 0 37 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="11.4512" cy="11.6401" r="11.0703" fill="#FF1D1D"/>
<circle cx="25.7783" cy="11.6401" r="11.0703" fill="#FFBE41" fill-opacity="0.88"/>
</svg>

`;
